import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const DRAWER_SESSION_KEY = 'wn_drawer_closed';
const DESKTOP_BREAKPOINT = 1030;

const initialState = {
  whichUserFlow: 'home-flow',
  isSideDrawerOpen:
    window.innerWidth >= DESKTOP_BREAKPOINT &&
    sessionStorage.getItem(DRAWER_SESSION_KEY) !== 'true',
} satisfies NavigationStateType as NavigationStateType;

const navigationSlice = createSlice({
  name: 'navigationSlice',
  initialState,
  reducers: {
    setCurrentUserflow: (
      state: NavigationStateType,
      action: PayloadAction<any>
    ) => {
      const currentUserFlow = action.payload;
      const leavingAuthFlow = state.whichUserFlow === 'auth-flow' && currentUserFlow !== 'auth-flow';
      state.whichUserFlow = currentUserFlow;
      if (currentUserFlow === 'auth-flow') {
        state.isSideDrawerOpen = false;
      } else if (leavingAuthFlow && window.innerWidth >= DESKTOP_BREAKPOINT && sessionStorage.getItem(DRAWER_SESSION_KEY) !== 'true') {
        state.isSideDrawerOpen = true;
      }
    },
    setIsSideDrawerOpen: (
      state: NavigationStateType,
      action: PayloadAction<boolean>
    ) => {
      state.isSideDrawerOpen = action.payload;
      if (!action.payload) {
        sessionStorage.setItem(DRAWER_SESSION_KEY, 'true');
      }
    },
  },
});

export const { setCurrentUserflow, setIsSideDrawerOpen } =
  navigationSlice.actions;

export default navigationSlice.reducer;
